import React from "react";
// import { ReactComponent as CopyrightIcon } from "../../../app/assets/images/copyright.svg";
// import { ReactComponent as TwitterIcon } from "../../../app/assets/images/twitter.svg";
// import { ReactComponent as FacebookIcon } from "../../../app/assets/images/facebook.svg";
// import { ReactComponent as LinkedinIcon } from "../../../app/assets/images/linkedin.svg";
import "./footer.scss";

const Footer = () => {
  // added min height for footer as we removed the content, remove that style when content is added
  return (
    <div className="portal-footer py-2 px-2" id="footer">
      {/* <div className="footer-left">
        <div className="footer-copyright footer-left">
          <div className="d-flex align-items-center">
            <>
              <CopyrightIcon className="mx-1" /> {`${new Date().getFullYear()}`}
            </>

            <div className="ms-2 footer-brand-title">
              White Label Communications.{" "}
              <span className="ms-2">All rights reserved.</span>
            </div>
          </div>
          <div>
            <a
              href="/terms-and-conditions"
              target="blank"
              className="terms-and-conditions"
            >
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>

      <div className="link-icons footer-right">
        <a href="https://www.facebook.com/whitelabelcomm" target="blank">
          <FacebookIcon className="mx-1" />
        </a>
        <a href="https://x.com/WhiteLabelVoIP" target="blank">
          <TwitterIcon className="mx-1" />
        </a>
        <a
          href="https://www.linkedin.com/company/white-label-communications-llc/mycompany/"
          target="blank"
        >
          <LinkedinIcon className="ms-1 me-3" />
        </a>
      </div> */}
    </div>
  );
};

export default Footer;
